import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import type { UserRole } from '@/types';

interface AuthGuardProps {
  children: ReactNode;
  requiredRoles?: UserRole[];
  blockedRoles?: UserRole[];
}

export default function AuthGuard({ children, requiredRoles, blockedRoles }: AuthGuardProps) {
  const { isAuthenticated, isLoading, currentUser } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center bg-background">
        <div className="flex flex-col items-center gap-3">
          <div className="h-10 w-10 animate-spin rounded-full border-4 border-primary border-t-transparent" />
          <p className="text-sm text-muted-foreground">Loading…</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (currentUser) {
    if (requiredRoles && !requiredRoles.includes(currentUser.role)) {
      return <Navigate to="/dashboard" replace />;
    }
    if (blockedRoles && blockedRoles.includes(currentUser.role)) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return <>{children}</>;
}
